import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Avatar,
  Button,
  Typography,
} from '@mui/material';
import { useLocation } from 'react-router';
import CustomLink from '@/components/CustomLink';
import { Arrow } from '@/static';
import { useBackNavigation } from '@/routes/useBackNavigation';
import styles from './styles';

type SidebarMenuItem = {
  path: string;
  label: string;
  icon?: React.ReactElement;
};

type SidebarMenuProps = {
  items: SidebarMenuItem[];
};

const SidebarMenu = ({ items }: SidebarMenuProps) => {
  const location = useLocation();
  const goBack = useBackNavigation();

  return (
    <Box sx={styles.root}>
      {location.pathname !== '/' && (
        <Box sx={styles.property}>
          <Avatar
            src="/athletiko-avatar.png"
            alt="property logo"
            sx={styles.avatar}
          />

          <Typography>Athletiko.gr</Typography>
        </Box>
      )}

      <List sx={styles.list}>
        {items.map((item, index) => {
          const isActive =
            location.pathname === item.path ||
            (!items.some((i) => i.path === location.pathname) && index === 0);

          return (
            <ListItem key={item.path} disablePadding sx={styles.listItem}>
              <ListItemButton
                component={CustomLink}
                to={item.path}
                sx={{
                  ...styles.listItemButton,
                  ...(item.icon ? styles.withIcon : styles.noIcon),
                }}
                selected={isActive}
                aria-current={isActive ? 'page' : undefined}
              >
                {item.icon && (
                  <ListItemIcon sx={styles.listItemIcon}>
                    {item.icon}
                  </ListItemIcon>
                )}

                <ListItemText sx={styles.text} primary={item.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>

      {location.pathname !== '/' && (
        <Button onClick={goBack} sx={styles.backButton}>
          <Arrow />
          <Typography sx={{ ml: 1 }}>Back to Properties</Typography>
        </Button>
      )}
    </Box>
  );
};

export default SidebarMenu;
